<script setup lang="ts">
import { ref } from 'vue'
import Modal from '@/components/ui/Modal.vue'
import { api, extractError } from '@/api/client'
import { useKeysStore } from '@/stores/keys'

const props = defineProps<{
  open: boolean
  keyId: number
}>()

const emit = defineEmits<{ close: [] }>()

const keys = useKeysStore()
const code = ref('')
const status = ref<'idle' | 'processing' | 'success' | 'error'>('idle')
const message = ref('')

function reset() {
  code.value = ''
  status.value = 'idle'
  message.value = ''
}

async function submit() {
  const value = code.value.trim()
  if (!value) {
    message.value = 'Введите код продления'
    status.value = 'error'
    return
  }
  status.value = 'processing'
  message.value = ''
  try {
    const { data } = await api.post<{ success: boolean; message?: string }>(
      '/api/user/renewal-activation',
      { key_id: props.keyId, key_code: value },
    )
    // #region agent log
    fetch('http://127.0.0.1:7656/ingest/7713647f-a8f6-4401-8735-77aece54bdec', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Debug-Session-Id': 'af34e8' },
      body: JSON.stringify({
        sessionId: 'af34e8',
        hypothesisId: 'H1',
        location: 'ExtendKeyModal.vue:submit',
        message: 'renewal response',
        data: { success: data.success, msg: data.message, keyId: props.keyId },
        timestamp: Date.now(),
      }),
    }).catch(() => {})
    // #endregion
    if (data.success) {
      status.value = 'success'
      message.value = data.message || 'Ключ продлён'
      await keys.fetch(true)
    } else {
      status.value = 'error'
      message.value = data.message || 'Не удалось продлить ключ'
    }
  } catch (e) {
    status.value = 'error'
    message.value = extractError(e, 'Не удалось продлить ключ')
  }
}

function close() {
  reset()
  emit('close')
}
</script>

<template>
  <Modal :open="open" title="Продлить ключ" max-width="md" @close="close">
    <form v-if="status !== 'success'" class="space-y-4" @submit.prevent="submit">
      <label for="renewal-code" class="text-sm text-muted">Код продления</label>
      <input
        id="renewal-code"
        v-model="code"
        type="text"
        maxlength="64"
        autocomplete="off"
        class="form-input font-mono"
        placeholder="Введите код"
        :disabled="status === 'processing'"
      />
      <div v-if="status === 'error'" class="alert alert-danger">{{ message }}</div>
    </form>

    <div v-else class="alert alert-success">{{ message }}</div>

    <template #footer>
      <button v-if="status !== 'success'" type="button" class="btn btn-outline-danger" @click="close">
        Отмена
      </button>
      <button
        v-if="status !== 'success'"
        type="button"
        class="btn btn-primary"
        :disabled="status === 'processing' || !code.trim()"
        @click="submit"
      >
        {{ status === 'processing' ? 'Продление…' : 'Продлить' }}
      </button>
      <button v-else type="button" class="btn btn-primary" @click="close">
        Готово
      </button>
    </template>
  </Modal>
</template>
